<template>
  <div id="rtc">
    <div class="local-video">
      <div id="video"></div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import TRTC from 'trtc-js-sdk'
import * as LibGenerateTestUserSig from '@/assets/usersig.min'

export default {
  name: 'rtcvideo',
  data() {
    return {
      state: false,
      SDKAPPID: 1400489128,
      EXPIRETIME: 604800,
      SECRETKEY: '8dbaf4cc8a52d3267d9617c663938254beb7ba44b40987fa5781dcc79ee82dfa',
      rtcVideo: null,
      userId: 'htwlgs22',
      roomID: 0,
      localStream: null,
      remoteStream: null,
    }
  },
  methods: {
    init(roomID) {
      this.state = true
      if (this.rtcVideo && this.rtcVideo.leave) {
        this.rtcVideo.leave()
      }
      this.roomID = parseInt(roomID, 0)
      this.rtcVideo = TRTC.createClient({
        mode: 'rtc',
        sdkAppId: this.SDKAPPID,
        userId: this.userId,
        useStringRoomId: false,
        userSig: this.genTestUserSig(this.userId).userSig,
      })

      // this.initLocal();

      this.rtcVideo.on('stream-added', (event) => {
        this.remoteStream = event.stream
        this.rtcVideo.subscribe(event.stream)
      })

      this.rtcVideo.on('stream-subscribed', (event) => {
        event.stream.play('video')
      })

      this.join()
    },
    async initLocalStream() {
      let cameraDevices = await TRTC.getCameras()
      let video = false
      if (cameraDevices && cameraDevices.length > 0) {
        video = true
      }
      this.localStream = TRTC.createStream({
        userId: this.userId,
        audio: true,
        video: video,
      })

      this.localStream
        .initialize()
        .catch((error) => {
          console.log(error)
        })
        .then((res) => {
          console.log(res)
          if (!this.state) {
            this.leave()
          } else {
            this.publish()
            this.localStream.play('video')
          }
        })
    },
    genTestUserSig(userID) {
      const generator = new LibGenerateTestUserSig(this.SDKAPPID, this.SECRETKEY, this.EXPIRETIME)
      const userSig = generator.genTestUserSig(userID)

      return {
        sdkAppID: this.SDKAPPID,
        userSig,
      }
    },
    join() {
      this.rtcVideo
        .join({
          roomId: this.roomID,
        })
        .catch((error) => {
          console.log(`进房间失败: ${error}`)
        })
        .then((res) => {
          console.log(`进房间成功：${res}`)
          // this.publish();
          this.initLocalStream()
        })
    },
    publish() {
      this.rtcVideo
        .publish(this.localStream)
        .catch((error) => {
          console.log(`发布本地流失败：${error}`)
          if (!this.state) {
            this.leave()
          }
        })
        .then((res) => {
          console.log(`发布本地流成功：${res}`)
          if (!this.state) {
            this.leave()
          }
        })
    },
    unpublish() {
      if (this.rtcVideo && this.rtcVideo.unpublish) {
        this.rtcVideo.unpublish(this.localStream)
      }
    },
    async unsubscribe() {
      if (this.rtcVideo && this.rtcVideo.unsubscribe && this.remoteStream) {
        await this.rtcVideo.unsubscribe(this.remoteStream).catch((e) => {
          this.remoteStream = null
        })
        this.remoteStream = null
      }
    },
    async leave() {
      let _this = this
      this.state = false
      navigator.getUserMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia

      if (navigator.getUserMedia) {
        navigator.getUserMedia(
          { video: true, audio: true },
          async function onSuccess(stream) {
            if (_this.localStream) {
              const videoTrack = _this.localStream.getVideoTrack()
              if (videoTrack) {
                await _this.localStream.removeTrack(videoTrack)
                // 停止采集，关闭摄像头
                videoTrack.stop()
              }
              // 关闭麦克风
              await _this.localStream.muteAudio()
              const audioTrack = _this.localStream.getAudioTrack()
              if (audioTrack) {
                audioTrack.stop()
              }
            }
          },
          function onError(error) {}
        )
      } else {
      }
      await this.unpublish()
      await this.unsubscribe()
      if (this.rtcVideo && this.rtcVideo.leave) {
        await this.rtcVideo.leave()
        await this.rtcVideo.destroy()
        document.getElementById('video').innerHTML = ''
      }
    },
  },
  mounted() {
    // this.init();
  },
}
</script>
<style lang="scss" scoped>
#rtc {
  width: 100%;
  height: 50%;

  .local-video {
    height: 100%;

    #video {
      width: 100%;
      height: 100%;
      object-fit: fill;
      // :deep(video) {
      //   width: auto !important;
      // }
    }
  }
}
</style>
